import { PropsWithChildren } from 'react';
import { MobileDrawer } from '@Components/Base/MDrawer';
import { ViewModal } from '@Components/ViewModal';
import { ViewResolver } from '@Components/ViewResolver';

import styles from './view-widget.module.css';

interface ViewWidgetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  height?: number;
  width?: number;
}

const ViewWidget: React.FC<PropsWithChildren<ViewWidgetProps>> = ({
  isOpen,
  onClose,
  title = 'Request Details',
  children,
  height,
  width,
}) => {
  return (
    <ViewResolver
      desktop={
        <ViewModal
          title={title}
          isModalOpen={isOpen}
          handleCancel={onClose}
          height={height}
          width={width}
        >
          {children}
        </ViewModal>
      }
      mobile={
        <MobileDrawer
          className={styles.mobileViewWidget}
          title={title}
          open={isOpen}
          onClose={onClose}
        >
          {children}
        </MobileDrawer>
      }
    />
  );
};

export default ViewWidget;
